import { jsx as _jsx } from "react/jsx-runtime";
import { Chip as HeroChip } from '@heroui/react';
export const Chip = (props) => {
    return _jsx(HeroChip, { ...props });
};
export default Chip;
//# sourceMappingURL=Chip.js.map